import { Instance } from 'mobx-state-tree';
import { GroupStore } from '../../../store';
import { inject, observer } from 'mobx-react';
import React from 'react';
import SelectInputFormField from './SelectInputFormField';

import { IItemRendererProps } from '@blueprintjs/select';
import { MenuItem } from '@blueprintjs/core';
import { TLCode } from '../../../common/enums';
import { toJS } from 'mobx';
import withTranslate, { WithTranslateProps } from '../WithTranslate';
import { Group } from '../../../store/models/Group';

interface GroupFormFieldProps extends WithTranslateProps {
  GroupStore?: Instance<typeof GroupStore>;
  groupList?: Array<Instance<typeof Group>>;
}

@inject('GroupStore')
@observer
class GroupFormField extends React.Component<GroupFormFieldProps> {
  renderGroupMenuItem(item: Instance<typeof Group>, { handleClick, index, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return (
        <MenuItem
          key={`group-${index}`}
          active={modifiers.active}
          onClick={handleClick}
          text={item.name + ' - ' + item.description!}
        />
      );
    } else {
      return null;
    }
  }

  filterGroup = (query, group) => {
    return (group.name + ' - ' + group.description!).toLowerCase().indexOf(query.toLowerCase()) >= 0;
  };

  render() {
    const { GroupStore, ...otherProps } = this.props;
    let { groupList } = this.props;
    if (groupList == null) {
      groupList = GroupStore!.dataList;
    }

    return (
      <>
        <SelectInputFormField
          label={TLCode.GROUP}
          name="groupId"
          inline={true}
          items={toJS(groupList)}
          itemValueGetter={(item: { groupId: number; name: string; description: string }) => item.groupId}
          valueItemGetter={(value) => GroupStore!.getById(value)!}
          inputValueRenderer={(item) => (item != null ? item.name + '-' + item.description! : '')}
          itemRenderer={this.renderGroupMenuItem}
          itemPredicate={this.filterGroup}
          identifier={'groupId'}
          elementLabel={'name'}
          labelSelectAnElement={this.props.translate(TLCode.CHOOSE_A_GROUP)}
          helperText={this.props.translate(TLCode.CHOOSE_A_GROUP)}
          placeholderSelection={TLCode.CHOOSE_A_GROUP}
          {...otherProps}
        />
      </>
    );
  }
}

export default withTranslate(GroupFormField);
